import classNames from "classnames";

export function getDashboardPreviewTableClassName(isSingleColumn: boolean) {
  return classNames("w-full max-w-full", isSingleColumn ? "table-auto" : "table-fixed");
}

export const DASHBOARD_TABLE_CARD_BODY_CLASS = "min-w-0";
